/* Built In Imports */
import Head from 'next/head';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import { EOEContextProvider } from '@store/EOEContext';
import RenderSections from 'landing_pages/eoe/Common/RenderSections';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
  getCurrentRegion,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/eventsService';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Sadhguru In Australia Landing Page Data
 */
const EOEPage = ({ region, language, pageData }) => {
  const [cityId, setCityId] = useState(null);
  const searchParams = useSearchParams();
  const router = useRouter();
  const cId = config.ENV_NAME === 'production' ? '7838' : '1114';

  useEffect(() => {
    localData();
  }, [router]);

  const localData = async () => {
    const reg = await getCurrentRegion(searchParams.get('country'));
    pageData.city = cId;
    pageData.cityName = 'Mumbai';
    setCityId(cId);
    pageData.country = reg?.country;
  };

  return (
    <WrapLayout>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>

      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box
        as="section"
        className="page-wrap container-article"
        padding="0 !important"
        maxW="1920px !important"
      >
        {pageData?.body?.map(section => {
          return (
            <EOEContextProvider>
              <RenderSections
                pageData={pageData}
                section={section}
                region={region}
                lang={language}
                cityId={cityId}
                setCityId={setCityId}
                // key={nanoid(4)}
              />
            </EOEContextProvider>
          );
        })}
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const eoeLandingPaths = config.USE_LOCAL_URL
    ? [`/in/en/events/special-events/ecstasy-of-enlightenment-mumbai`,
      `/au/en/events/special-events/ecstasy-of-enlightenment-mumbai`,
    ]
    : await getLandingPaths(
        'L2',
        '/events/special-events/ecstasy-of-enlightenment-mumbai'
      );
  return {
    paths: eoeLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    region,
    language,
    `special-events/ecstasy-of-enlightenment-mumbai`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default EOEPage;
